(() => {
  'use strict';
  const settings = document.currentScript?.dataset || {};
  const selector = 'body.template-product #MainContent #judgeme_product_reviews';
  const observed = new WeakMap();

  function enhance(widget) {
    const header = widget.querySelector('.jdgm-rev-widg__header');
    const title = header?.querySelector('.jdgm-rev-widg__title');
    if (!header || !title) return;
    if (!header.querySelector('.sk-olive-review-eyebrow')) {
      const eyebrow = document.createElement('span');
      eyebrow.className = 'sk-olive-review-eyebrow';
      eyebrow.textContent = title.textContent;
      header.prepend(eyebrow);
    }
    if (settings.headline && title.textContent !== settings.headline) title.textContent = settings.headline;
    if (!header.querySelector('.sk-olive-review-subtitle') && settings.subtitle) {
      const subtitle = document.createElement('p');
      subtitle.className = 'sk-olive-review-subtitle';
      subtitle.textContent = settings.subtitle;
      title.after(subtitle);
    }
    const summary = header.querySelector('.jdgm-rev-widg__summary-stars');
    const rating = widget.querySelector('.jdgm-rev-widg')?.getAttribute('data-average-rating');
    if (summary && rating && Number.isFinite(Number(rating))) {
      let score = summary.querySelector('.sk-olive-review-score');
      if (!score) {
        score = document.createElement('span');
        score.className = 'sk-olive-review-score';
        score.setAttribute('aria-hidden','true');
        summary.prepend(score);
      }
      if (score.textContent !== rating + ' / 5') score.textContent = rating + ' / 5';
    }
    const sort = widget.querySelector('.jdgm-rev-widg__sort-wrapper');
    const actions = widget.querySelector('.jdgm-widget-actions-wrapper');
    if (sort && actions) {
      let toolbar = header.querySelector('.sk-olive-review-toolbar');
      if (!toolbar) {
        toolbar = document.createElement('div');
        toolbar.className = 'sk-olive-review-toolbar';
        header.append(toolbar);
      }
      if (sort.parentElement !== toolbar) toolbar.append(sort);
      if (actions.parentElement !== toolbar) toolbar.append(actions);
    }
    const rail = widget.querySelector('.jdgm-rev-widg__reviews');
    if (rail && !rail.hasAttribute('tabindex')) {
      rail.setAttribute('tabindex','0');
      rail.setAttribute('role','region');
      rail.setAttribute('aria-label',header.querySelector('.sk-olive-review-eyebrow').textContent);
    }
    const body = widget.querySelector('.jdgm-rev-widg__body');
    if (body && !body.querySelector('.sk-olive-review-caption') && settings.caption) {
      const caption = document.createElement('p');
      caption.className = 'sk-olive-review-caption';
      caption.textContent = settings.caption;
      body.append(caption);
    }
    widget.querySelectorAll('.jdgm-rev__body').forEach(body => {
      if (!body.hasAttribute('tabindex')) body.setAttribute('tabindex','0');
    });
    widget.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link:first-child .jdgm-rev__pic-img').forEach(img => {
      const link = img.closest('a');
      const source = link?.getAttribute('data-mfp-src') || link?.getAttribute('href');
      if (!source) return;
      try {
        const url = new URL(source, location.origin);
        if (url.hostname !== 'review-images.judgeme.com') return;
        url.searchParams.set('width','720');
        if (img.getAttribute('src') !== url.href) img.setAttribute('src',url.href);
        if (img.getAttribute('data-src') !== url.href) img.setAttribute('data-src',url.href);
      } catch {}
    });
  }

  function initialize(scope = document) {
    scope.querySelectorAll(selector).forEach(widget => {
      if (observed.has(widget)) return;
      enhance(widget);
      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => {
          queued = false;
          if (!widget.isConnected) { observer.disconnect(); return; }
          enhance(widget);
        });
      });
      observer.observe(widget,{childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating']});
      observed.set(widget,observer);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(),{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll(selector).forEach(widget => observed.get(widget)?.disconnect()));
})();
